export default "__VITE_ASSET__B26fOhAG__"